import React from "react";
import CelebrationSection from './CelebrationSection';
import ProductsSection from './ProductsSection';
import FAQSection from './FAQSection';
import './CelebrationPage.css';

export default function CelebrationPage() {
  return (
    <div className="celebration-page">
      <div className="space-y-16 p-4 max-w-6xl mx-auto font-sans">
        <CelebrationSection />
        <ProductsSection />
        <FAQSection />
      </div>
    </div>
  );
}
